module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tenders/tenders.component.css
// module id = ./src/app/components/tenders/tenders.component.css
// module chunks = main